import { render } from "./moneyFormatting.vue?vue&type=template&id=376d1f0c&scoped=true"
import script from "./moneyFormatting.vue?vue&type=script&lang=js"
export * from "./moneyFormatting.vue?vue&type=script&lang=js"

import "./moneyFormatting.vue?vue&type=style&index=0&id=376d1f0c&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376d1f0c"]])

export default __exports__